"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _localization = _interopRequireDefault(require("../../../../localization"));
var _pluralTranslations = require("../../../../localization/pluralTranslations");
var _CompactCardView = _interopRequireDefault(require("../../../CompactCardView"));
var _constants = require("../../store/constants");
var _group = _interopRequireDefault(require("./group.svg"));
var _star = _interopRequireDefault(require("./star.svg"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var getIconPropsByType = function getIconPropsByType(type) {
  return !R.equals(_constants.COLLECTION_TYPES.USER, type) ? {
    icon: {
      element: R.call(R.cond([[R.equals(_constants.COLLECTION_TYPES.TF), R.always(_group.default)], [R.equals(_constants.COLLECTION_TYPES.PROJECT), R.always(_star.default)]]), type),
      title: R.call(R.pipe(R.cond([[R.equals(_constants.COLLECTION_TYPES.USER), R.always('OWN')], [R.equals(_constants.COLLECTION_TYPES.TF), R.always('AGENT')], [R.equals(_constants.COLLECTION_TYPES.PROJECT), R.always('GENERAL')]]), function (localeKey) {
        return _localization.default.t("COLLECTION:".concat(localeKey));
      }), type)
    }
  } : undefined;
};
var getCollectionImage = function getCollectionImage(hotels) {
  return R.call(R.pipe(R.head, R.prop('image'), R.when(Boolean, function (src) {
    return (0, _dictionary.getImageUrl)(src, 'small');
  })), hotels);
};
var createHotelsCountriesJSX = function createHotelsCountriesJSX(hotels) {
  return R.call(R.pipe(R.map(R.path(['country', 'name'])), R.uniq, R.join(', '), function (countriesStringify) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', /*#__PURE__*/_react.default.createElement("i", null, "|"), ' ', /*#__PURE__*/_react.default.createElement("span", {
      title: countriesStringify
    }, countriesStringify));
  }), hotels);
};
var createDescriptionJSX = function createDescriptionJSX(hotels, hotelsTranslation) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("nobr", null, hotels.length, ' ', hotelsTranslation(hotels.length)), !R.isEmpty(hotels) && createHotelsCountriesJSX(hotels));
};
var Collection = function Collection(_ref) {
  var active = _ref.active,
    allowEditable = _ref.allowEditable,
    className = _ref.className,
    deleting = _ref.deleting,
    disabled = _ref.disabled,
    editing = _ref.editing,
    isCollapsed = _ref.isCollapsed,
    type = _ref.type,
    name = _ref.name,
    hotels = _ref.hotels,
    onArrowButtonClick = _ref.onArrowButtonClick,
    onClick = _ref.onClick,
    onCollapseButtonClick = _ref.onCollapseButtonClick,
    onDeleteButtonClick = _ref.onDeleteButtonClick,
    onEditTitle = _ref.onEditTitle;
  var hotelsTranslation = (0, _pluralTranslations.usePluralHotelsTranslation)();
  return /*#__PURE__*/_react.default.createElement(_CompactCardView.default, {
    active: active,
    className: className,
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Image, {
    src: getCollectionImage(hotels)
  }), /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Body, _extends({}, getIconPropsByType(type), {
    allowEditable: allowEditable,
    description: createDescriptionJSX(hotels, hotelsTranslation),
    editing: editing,
    title: name,
    onEditTitle: onEditTitle
  })), /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Buttons, {
    deleting: deleting,
    isCollapsed: isCollapsed,
    onArrowButtonClick: onArrowButtonClick,
    onCollapseButtonClick: onCollapseButtonClick,
    onDeleteButtonClick: onDeleteButtonClick
  }));
};
Collection.propTypes = {
  hotels: _propTypes.default.array.isRequired,
  name: _propTypes.default.string.isRequired,
  type: _propTypes.default.oneOf(Object.values(_constants.COLLECTION_TYPES)).isRequired,
  active: _propTypes.default.bool,
  allowEditable: _propTypes.default.bool,
  className: _propTypes.default.string,
  deleting: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  editing: _propTypes.default.bool,
  isCollapsed: _propTypes.default.bool,
  onArrowButtonClick: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onCollapseButtonClick: _propTypes.default.func,
  onDeleteButtonClick: _propTypes.default.func,
  onEditTitle: _propTypes.default.func
};
var _default = exports.default = Collection;